import { useMutation } from 'react-query';
import { network } from 'services/network';

const setCheckerConfigParams = (params) => {
    return network.post('api/bo/setCheckerConfigParams', params).then((response) => {
        return response.data;
    });
};
export const useMutationSetCheckerConfigParams = () => {
    return useMutation<any, QueryError, ConfigParams>('setCheckerConfigParams', (params) =>
        setCheckerConfigParams(params),
    );
};

export interface ConfigParams {
    configId: number;
    lowerLimit: number;
    upperLimit: number;
    metaDataId: number;
}
